import { useState, useEffect } from 'react';

interface AuthState {
  isAuthenticated: boolean;
  user: any | null;
  token: string | null;
  isLoading: boolean;
}

let globalSetAuthState: React.Dispatch<React.SetStateAction<AuthState>> | null = null;

export const useOfflineAuth = () => {
  const [authState, setAuthState] = useState<AuthState>({
    isAuthenticated: false,
    user: null,
    token: null,
    isLoading: true
  });

  useEffect(() => {
    globalSetAuthState = setAuthState;
    return () => {
      globalSetAuthState = null;
    };
  }, []);

  const checkAuthStatus = async () => {
    try {
      const token = localStorage.getItem('authToken');
      const userData = localStorage.getItem('userData');
      
      if (!token) {
        setAuthState({
          isAuthenticated: false,
          user: null,
          token: null,
          isLoading: false
        });
        return;
      }

      const tokenExpiry = localStorage.getItem('tokenExpiry');
      if (tokenExpiry && Date.now() > parseInt(tokenExpiry)) {
        clearOfflineAuth();
        return;
      }

      if (userData) {
        setAuthState({
          isAuthenticated: true,
          user: JSON.parse(userData),
          token,
          isLoading: false
        });
      }
    } catch (error) {
      setAuthState({
        isAuthenticated: false,
        user: null,
        token: null,
        isLoading: false
      });
    }
  };

  useEffect(() => {
    checkAuthStatus();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const refreshAuth = () => {
    checkAuthStatus();
  };

  return {
    ...authState,
    refreshAuth
  };
};

// Funkcje do zarządzania autentykacją z innych hooków
export const setOfflineAuth = (data: { token: string; user?: any; expiresIn?: number }) => {
  const { token, user, expiresIn } = data;
  
  localStorage.setItem('authToken', token);
  
  // Tylko zapisz userData jeśli został podany
  if (user) {
    localStorage.setItem('userData', JSON.stringify(user));
  }
  
  if (expiresIn) {
    const expiryTime = Date.now() + (expiresIn * 1000);
    localStorage.setItem('tokenExpiry', expiryTime.toString());
  }

  if (globalSetAuthState) {
    globalSetAuthState({
      isAuthenticated: !!token,
      user: user || null,
      token,
      isLoading: false
    });
  }
};

export const clearOfflineAuth = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('userData');
  localStorage.removeItem('tokenExpiry');
  localStorage.removeItem('offlineData');

  // Aktualizuj stan jeśli hook jest aktywny
  if (globalSetAuthState) {
    globalSetAuthState({
      isAuthenticated: false,
      user: null,
      token: null,
      isLoading: false
    });
  }
};